export default __webpack_public_path__ + "static/media/growth-notes-logo_black.b46d1ff8.png";